export default "__VITE_ASSET__DWbtAqOv__"